"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGlobalDialogViewCallbacks = exports.useGlobalDialogFormCallbacks = void 0;
const store_1 = require("../store");
const useGlobalDialogFormCallbacks = () => {
    const openDialog = (0, store_1.useGlobalFormDialogStore)(s => s.openDialog);
    const closeDialog = (0, store_1.useGlobalFormDialogStore)(s => s.closeDialog);
    return {
        openDialog,
        closeDialog,
    };
};
exports.useGlobalDialogFormCallbacks = useGlobalDialogFormCallbacks;
const useGlobalDialogViewCallbacks = () => {
    const openViewDialog = (0, store_1.useGlobalViewDialogStore)(s => s.openDialog);
    const closeViewDialog = (0, store_1.useGlobalViewDialogStore)(s => s.closeDialog);
    return {
        openViewDialog,
        closeViewDialog,
    };
};
exports.useGlobalDialogViewCallbacks = useGlobalDialogViewCallbacks;
//# sourceMappingURL=index.js.map